import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import Config from '../utils/config.service';
import HttpHelper from '../utils/http-helper.service';

@Injectable({ providedIn: 'root' })
export default class ToolkitService {
	private httpClient: HttpClient = inject(HttpClient);
	private config: Config = inject(Config);
	private httpHelper: HttpHelper = inject(HttpHelper);

	getCatalogue(params?, successCallback?, errorCallback?) {
		const httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/api/toolkit/v1/catalogue', {
			withCredentials: true,
			params: params
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getClients(params?, successCallback?, errorCallback?) {
		const httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/api/toolkit/v1/clients', {
			withCredentials: true,
			params: params
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	// ToolkitApiResource: "clients" is the SP customer roster (derived from toolkit assignments/surveys).
	// Caller can pass { q } to filter by name server-side.
	getUserCustomers(params?, successCallback?, errorCallback?) {
		const httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/api/toolkit/v1/clients', {
			withCredentials: true,
			params: params
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}


	getClientDetail(params, successCallback?, errorCallback?) {
		const httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/api/toolkit/v1/clients/' + params.id, {
			withCredentials: true,
			params: params
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getResource(params, successCallback?, errorCallback?) {
		const httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/api/toolkit/v1/resources/' + params.id, {
			withCredentials: true,
			params: params
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getAssessment(params, successCallback?, errorCallback?) {
		const httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/api/toolkit/v1/assessments/' + params.id, {
			withCredentials: true,
			params: params
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	createAssignment(data, successCallback?, errorCallback?) {
		const httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/api/toolkit/v1/assignments', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getAssignments(params?, successCallback?, errorCallback?) {
		const httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/api/toolkit/v1/assignments', {
			withCredentials: true,
			params: params
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getAssessmentAssignments(params?, successCallback?, errorCallback?) {
		const httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/api/toolkit/v1/assessment-assignments', {
			withCredentials: true,
			params: params
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	createAssessmentAssignment(data, successCallback?, errorCallback?) {
		const httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'rest/api/toolkit/v1/assessment-assignments', data, {
			withCredentials: true
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	submitMyCompletion(params, data, successCallback?, errorCallback?) {
		const httpPromise: any = this.httpClient.post(
			this.config.getRestUrl() + 'rest/api/toolkit/v1/me/assignments/' + params.assignmentId + '/completions',
			data,
			{ withCredentials: true }
		);
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getMyAssignment(params, successCallback?, errorCallback?) {
		const httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/api/toolkit/v1/me/assignments/' + params.id, {
			withCredentials: true,
			params: params
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getMyAssignmentsList(params?, successCallback?, errorCallback?) {
		const httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/api/toolkit/v1/me/assignments', {
			withCredentials: true,
			params: params
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getMyAssessmentAssignmentsList(params?, successCallback?, errorCallback?) {
		const httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/api/toolkit/v1/me/assessment-assignments', {
			withCredentials: true,
			params: params
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getMyAssessmentAssignment(params, successCallback?, errorCallback?) {
		const httpPromise: any = this.httpClient.get(
			this.config.getRestUrl() + 'rest/api/toolkit/v1/me/assessment-assignments/' + params.id,
			{ withCredentials: true, params: params }
		);
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	submitMyAssessmentAnswers(params, data, successCallback?, errorCallback?) {
		const httpPromise: any = this.httpClient.post(
			this.config.getRestUrl() + 'rest/api/toolkit/v1/me/assessment-assignments/' + params.assignmentId + '/answers',
			data,
			{ withCredentials: true }
		);
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}
}
